import { useUserStore } from '@roc/feature-app-core';

export const useUserAgreementSigned = () => {
  const { userStore } = useUserStore();
  return userStore.userInformation?.signedUserAgreement !== false;
};
